import _ from 'lodash';
import { ControlType, Item } from '../../workspaces/item';
import Workspace from '../../workspaces';
import templates from '../templates';
import colorbrewer from '../tools/colorbrewer';

const serviceAreaStyle = (() => {
    let _visible = false;
    let $dialog = null;
    let $template = null;
    const eventCloseName = 'dialog-service-area-close';

    const _close = () => $dialog.close();

    const _onClose = () => {
        Workspace.addAction(new Item(eventCloseName, '', ControlType.GlobalEvent));
        _visible = false;
        $dialog.destroy();
        $template.remove();
    };

    return (name, style) => {
        if (_visible) { _close(); }

        _visible = true;

        let dataSourceColors;
        let dataSourceOpacity;
        let dataSourceWeight;
        const options = _.cloneDeep(style.options) || { firstOpened: true };

        if (typeof options.showRadiusReal === 'undefined' && typeof options.showRadiusTheoretical === 'undefined') {
            options.showRadiusReal = true;
            options.showRadiusTheoretical = false;
        }

        $template = $(templates('dialog-service-area-style'));

        const onChange = () => {
            if (!options.color) {
                options.color = JSON.parse(dataSourceColors[0].value);
            }

            if (typeof options.opacity === 'undefined') {
                options.opacity = dataSourceOpacity[1].value;
            }

            if (!options.weight) {
                options.weight = dataSourceWeight[1].value;
            }

            style.change(options, _onClose);
        };

        const _colorCanvas = (theme) => {
            const canvas = document.createElement('canvas');
            canvas.width = 44;
            canvas.height = 34;
            const ctx = canvas.getContext('2d');
            _.forEach(theme, (c, i) => {
                ctx.beginPath();
                const x = (i * canvas.width) / theme.length;
                const y = 0;
                ctx.rect(x, y, canvas.width / theme.length, canvas.height);
                ctx.fillStyle = c;
                ctx.fill();
            });
            return canvas.toDataURL('image/png');
        };

        dataSourceColors = _(colorbrewer)
            .transform((result, theme, text) => {
                if (_.isObject(theme)) {
                    _.forEach(theme, (colors, range) =>
                        result.push({
                            'text': text,
                            'value': JSON.stringify(colors),
                            'template': _colorCanvas(colors)
                        })
                    );
                }
            }, [])
            .value();

        $template.find('button[id="service-area-add"]').on('click', (e) => {
            e.preventDefault();
            options.firstOpened = false;
            onChange();
        });

        $template.find('button[id="service-area-cancel"]').on('click', (e) => {
            e.preventDefault();
            style.onDelete(_onClose);
        });

        $template.find('select[name="color"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            valueTemplate: `<img style="height: 27px; margin: -2px 0 0 -8px;" src="#: data.template #">`,
            template: `<img style="margin: 0 0 0 -5px" src="#: data.template #">`,
            dataSource: dataSourceColors,
            index: (options.color ? _.findIndex(dataSourceColors, (d) => d.value === JSON.stringify(options.color)) : 0),
            change: (e) => {
                const color = JSON.parse(e.sender.value());
                options.color = color;
                style.onStyle(options);
            }
        });

        dataSourceOpacity = [
            { text: 'Transparente', value: 0 },
            ...Array.from({ length: 10 }, (_, x) => x)
                .map(x => ({ text: `${((x + 1) * 10)}%`, value: (x + 1) / 10 }))
        ];

        $template.find('select[name="opacity"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: dataSourceOpacity,
            index: (typeof options.opacity !== 'undefined' ? _.findIndex(dataSourceOpacity, (d) => d.value == options.opacity) : 1),
            change: (e) => {
                options.opacity = parseFloat(e.sender.value());
                style.onStyle(options);
            }
        });

        dataSourceWeight = [
            ...Array.from({ length: 10 }, (_, x) => ({ text: `${(x + 1)}`, value: (x + 1) }))
        ];

        $template.find('select[name="weight"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: dataSourceWeight,
            index: (options.weight ? _.findIndex(dataSourceWeight, (d) => d.value == options.weight) : 1),
            change: (e) => {
                options.weight = parseFloat(e.sender.value());
                style.onStyle(options);
            }
        });

        $template.find('input[name="showRadius"]').iCheck({
            radioClass: 'iradio_square-blue',
            checkboxClass: 'icheckbox_square-blue',
            checked: options.showLabelRadius
        });

        if (options.showLabelRadius) {
            $template.find('input[name="showRadius"]').iCheck('check');
        }

        $template.find('input[name="showRadius"]').on("ifChanged", (e) => {
            options.showLabelRadius = e.target.checked;
            style.onStyle(options);
        });

        $template.find('input[name="showRadiusTheoretical"]').iCheck({
            radioClass: 'iradio_square-blue',
            checkboxClass: 'icheckbox_square-blue',
            checked: options.showRadiusTheoretical
        });

        if (options.showRadiusTheoretical) {
            $template.find('input[name="showRadiusTheoretical"]').iCheck('check');
        }

        $template.find('input[name="showRadiusTheoretical"]').on("ifChanged", (e) => {
            options.showRadiusTheoretical = e.target.checked;
        });

        $template.find('input[name="showRadiusReal"]').iCheck({
            radioClass: 'iradio_square-blue',
            checkboxClass: 'icheckbox_square-blue',
            checked: options.showRadiusReal
        });

        if (options.showRadiusReal) {
            $template.find('input[name="showRadiusReal"]').iCheck('check');
        }

        $template.find('input[name="showRadiusReal"]').on("ifChanged", (e) => {
            options.showRadiusReal = e.target.checked;
            style.onStyle(options);
        });

        const $btnGenerate = $template.find('button[id="service-area-add"]');
        const $chkPotential = $template.find('input[name="showRadiusTheoretical"]');
        const $chkReal = $template.find('input[name="showRadiusReal"]');

        let _syncing = false;

        const updateGenerateButton = () => {
        const enabled = !!(options.showRadiusTheoretical || options.showRadiusReal);
        $btnGenerate.prop('disabled', !enabled);
        $btnGenerate.toggleClass('disabled', !enabled);
        };

        $chkPotential.on('ifChecked', () => {
        if (_syncing) return;
        _syncing = true;

        options.showRadiusTheoretical = true;

        style.onStyle(options);
        updateGenerateButton();

        _syncing = false;
        });

        $chkPotential.on('ifUnchecked', () => {
        if (_syncing) return;

        options.showRadiusTheoretical = false;
        style.onStyle(options);
        updateGenerateButton();
        });

        $chkReal.on('ifChecked', () => {
        if (_syncing) return;
        _syncing = true;

        options.showRadiusReal = true;

        style.onStyle(options);
        updateGenerateButton();

        _syncing = false;
        });

        $chkReal.on('ifUnchecked', () => {
        if (_syncing) return;

        options.showRadiusReal = false;
        style.onStyle(options);
        updateGenerateButton();
        });

        updateGenerateButton();

        $dialog = $template.kendoWindow({
            width: '400px',
            resizable: false,
            draggable: true,
            visible: false,
            title: '',
            appendTo: 'body',
            close: _onClose
        }).data('kendoWindow');

        $(document).off(eventCloseName);
        $(document).on(eventCloseName, _onClose);

        $dialog.center().open();

        return $dialog;
    };
})();

export default serviceAreaStyle;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/service-area-style.js